import { API_CONFIG } from "@/config/api"

export function buildPublicFileUrl(path: string): string {
  return buildApiUrl(path)
}

export function buildPublicQrCodeUrl(code: string): string {
  return buildApiUrl(`/q/${code}`)
}

function buildApiUrl(path: string): string {
  const normalizedBase = API_CONFIG.BASE_URL.replace(/\/$/, "")
  const base = normalizedBase.startsWith("http")
    ? normalizedBase
    : `${window.location.origin}${normalizedBase}`

  return `${base}${path}`
}
